import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';

import { PreProcurementRoutingModule } from './pre-procurement-routing.module';
import { ProcurementParentComponent } from './procurement-parent/procurement-parent.component';
import { ProcurementListingComponent } from './procurement-listing/procurement-listing.component';
import { ProcurementViewComponent } from './procurement-view/procurement-view.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { ProcurementCreateComponent } from './procurement-create/procurement-create.component';
import { ProcurementBulkComponent } from './procurement-bulk/procurement-bulk.component';
import { PreProcurementNotesComponent } from './pre-procurement-notes/pre-procurement-notes.component';

@NgModule({
  declarations: [
    ProcurementParentComponent,
    ProcurementListingComponent,
    ProcurementViewComponent,
    ProcurementCreateComponent,
    ProcurementBulkComponent,
    PreProcurementNotesComponent,
  
  ],
  imports: [
    CommonModule,
    PreProcurementRoutingModule,
    FormsModule,
    SharedComponentsModule,
    ReactiveFormsModule,
    ButtonModule
  ],
  providers: [DatePipe],
})
export class PreProcurementModule {}
